import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  import { controls } from "../../controls";
  
  
  const jointaccount = {
    label: "Joint Account",
    pageLabel: "Joint Account",
    starting: true,
    url: "jointaccount",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form:[
        ...controls.displayText({label:"Joint Account Name",star:true, width:"col-sm-2"}),
        ...controls.text({placeHolder: "Joint Account Name",name: "joint_account_name",width:"col-sm-4"}),
        ...controls.displayText({ width:"col-sm-6"}),
        ...controls.displayText({label: "Code",width:"col-sm-2"}),
        ...controls.JointType({width:"col-sm-2"}),
        ...controls.showData({data:"jointtype_code_display",width:"col-sm-2"}),
        ...controls.displayText({label:"CIN",width:"col-sm-2"}),
        ...controls.customerNumber({width:"col-sm-2"}),
        ...controls.showData({data:"customer_number_display",width:"col-sm-2"}),
        ...controls.magicDateLabel({ label: "Date Added", width: "col-sm-2" }),
        ...controls.magicDate({dateType:"ontype", name: "date_added",width:"col-sm-2"}),
        ...controls.displayText({ width:"col-sm-2"}),
        ...controls.magicDateLabel({ label: "Upto Date", width: "col-sm-2" }),
        ...controls.magicDate({dateType:"ontype", name: "upto_date",width:"col-sm-2"}),
        ...controls.displayText({ width:"col-sm-2"}),
        ...controls.checkBox({label:"Sign Required",name:"isSignRequired",width:"col-sm-2"}),
        ...controls.button({
          label: "ADD", onclick: {
            action: "appendToHTMLTable",
            tableNameField: 'joint_account_table',
            requiredField: ["jointtype_code", "jointtype_code_display", "customer_number", "customer_number_display", "date_added", "upto_date", "isSignRequired"]
          }, width: "col-sm-2"
        }),
        {
            inputType: "table",
            tableTitle: "",
            // editable: true,
            // addRows: true,
            deletable: true,
            tableHeaders: [
              { label: "Sr", type: "autoinc" },
              { label: "Code", field: "jointtype_code"  },
              { label: "Joint Type", field: "jointtype_code_display" },
              { label: "CIN", field: "customer_number" },
              { label: "Full Names", field: "customer_number_display" },
              { label: "Date Added", displaytype: 'date',field: "date_added" ,displaytype:'date'},
              { label: "Upto Date", displaytype: 'date',field: "upto_date",displaytype:'date' },
              { label: "Sign Required", field: "isSignRequired",displaytype:'tick' }
            ],
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            name: "joint_account_table"
       },
    ]
  }

  export default jointaccount;